
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid } from '@mui/material';
import { useState } from 'react';
import { TFiltrosTarefas } from '../..';
import SelectFluxoProcesso from '../../../../components/SelectsSimpleApiQuery/SelectFluxoProcesso';
import { TFluxoProcesso } from '../../../../types/api/geral/fluxo-processo';
import PaperDraggable from '../../../../components/PaperDraggable';

export default function DialogFiltrosTarefas({ open, defFiltros, onClose, onApplyFilters }: DialogFiltrosTarefasProps) {

    const [filtros, setFiltros] = useState<TFiltrosTarefas | null>(defFiltros)

    const handleOnSubmit = () => {
        onApplyFilters(filtros);
    }

    const handleLimparFiltros = () => {
        setFiltros(null);
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Filtros</DialogTitle>
            <DialogContent>
                <Grid container mt={1}>
                    <Grid size={{xs: 12}}>
                        <SelectFluxoProcesso
                            multiple
                            value={filtros?.fluxo_contem || [] as TFluxoProcesso[]}
                            onChange={(value: TFluxoProcesso | null) => {
                                const fluxoValue = Array.isArray(value) ? value : value ? [value] : [];
                                setFiltros((prev) => ({ ...prev, fluxo_contem: fluxoValue }));
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>

                <Button onClick={handleLimparFiltros}>
                    Limpar
                </Button>

                <Button onClick={onClose}>
                    Cancelar
                </Button>
                <Button onClick={handleOnSubmit} color="primary" variant='contained'>
                    Aplicar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

interface DialogFiltrosTarefasProps {
    open: boolean;
    defFiltros: TFiltrosTarefas | null;
    onClose: () => void;
    onApplyFilters: (filtros: TFiltrosTarefas | null) => void;
}